import { PredictionsInfoContextValues } from './predictions-info-context';
import { useSyncCompleteEffect } from '../../../predict-management/hooks/useSyncCompleteEffect';

interface Props {
  fetchForecastReport?: PredictionsInfoContextValues['fetchForecastReport'];
}
/**
 * Renders nothing. Only mounted for non-consolidation routes where SyncContextProvider
 * is present. Refetches the forecast report when a datasource sync completes.
 */
export const SyncCompleteHandler = ({ fetchForecastReport }: Props) => {
  useSyncCompleteEffect(() => {
    fetchForecastReport?.('all');
  });

  return null;
};
